module.exports = __webpack_public_path__ + "img/af_yes.aa2a63da.png";